(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["film-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const MOBILE = '(max-width: 767px)';
    function initFilm(root) {
      if (root.dataset.filmInit) return;
      root.dataset.filmInit = '1';
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let video = null;
      const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          if (!video) {
            const src = matchMedia(MOBILE).matches ? root.dataset.srcMobile : root.dataset.srcDesktop;
            if (!src) return;
            video = document.createElement('video');
            video.className = 'film__media film__video';
            video.src = src; video.muted = true; video.loop = true; video.playsInline = true; video.autoplay = true; video.preload = 'none';
            video.setAttribute('aria-label', root.dataset.label || '');
            video.addEventListener('playing', () => video.setAttribute('data-ready', ''), { once: true });
            root.insertBefore(video, root.querySelector('.film__shade'));
          }
          video.play().catch(() => {});
        } else if (video) {
          video.pause();
        }
      }, { rootMargin: '200px 0px', threshold: 0 });
      io.observe(root);
    }
    const run = () => document.querySelectorAll('.film').forEach(initFilm);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.film').forEach(initFilm));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrival"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const EVENT = 'slideshow:select';

    function updateButtons(slideshow, prev, next) {
      const count = slideshow.slides?.length ?? 0;
      if (count <= 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      prev.disabled = Boolean(slideshow.atStart);
      next.disabled = Boolean(slideshow.atEnd);
    }

    function bindSection(root) {
      if (root.dataset.newArrivalNavBound === 'true') return;
      const nav = root.querySelector('[data-new-arrival-nav]');
      const slideshow = root.querySelector('slideshow-component');
      const prev = root.querySelector('.new-arrival__nav-btn--prev');
      const next = root.querySelector('.new-arrival__nav-btn--next');
      if (!nav || !slideshow || !prev || !next) return;

      root.dataset.newArrivalNavBound = 'true';

      const refresh = () => updateButtons(slideshow, prev, next);

      prev.addEventListener('click', () => slideshow.previous?.());
      next.addEventListener('click', () => slideshow.next?.());
      slideshow.addEventListener(EVENT, refresh);
      customElements.whenDefined('slideshow-component').then(() => {
        queueMicrotask(refresh);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-testid="new-arrival"]').forEach(bindSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (!(section instanceof HTMLElement)) return;
      const root = section.querySelector('[data-testid="new-arrival"]');
      if (root) bindSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
  class YusheTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.viewAll = this.querySelector('[data-view-all]');
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); this.select((i + 1) % this.tabs.length, true); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); this.select((i - 1 + this.tabs.length) % this.tabs.length, true); }
          if (e.key === 'Home') { e.preventDefault(); this.select(0, true); }
          if (e.key === 'End') { e.preventDefault(); this.select(this.tabs.length - 1, true); }
        });
      });
    }
    select(i, focus) {
      this.tabs.forEach((t, j) => { t.setAttribute('aria-selected', String(j === i)); t.tabIndex = j === i ? 0 : -1; });
      this.panels.forEach((p, j) => {
        p.hidden = j !== i;
        if (j === i) p.querySelectorAll('.arrivals__cell').forEach((c) => { c.style.animation = 'none'; void c.offsetWidth; c.style.animation = ''; });
      });
      if (this.viewAll && this.tabs[i].dataset.href) this.viewAll.href = this.tabs[i].dataset.href;
      if (focus) this.tabs[i].focus();
    }
  }
  if (!customElements.get('yushe-tabs')) customElements.define('yushe-tabs', YusheTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReels(track) {
      if (track.dataset.reelsInit) return;
      track.dataset.reelsInit = '1';
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // Rendered cards only (phones hide the marquee clones).
      const videos = [...track.querySelectorAll('video')].filter((v) => v.getClientRects().length);
      if (!videos.length) return;

      // Phones and slow / data-saver connections get the 480p file (nothing has loaded yet: preload="none").
      const c = navigator.connection || {};
      if (matchMedia('(max-width: 767px)').matches || c.saveData || /(^|-)(2g|3g)$/.test(c.effectiveType || '')) {
        videos.forEach((v) => { if (v.dataset.sd) v.src = v.dataset.sd; });
      }

      // Previews with an AV1 twin (data-av1, same quality, about a quarter smaller) use it where the browser
      // decodes AV1 (Safari without AV1 hardware does not; it keeps the H.264 file), falling back if it errors.
      const av1 = document.createElement('video').canPlayType('video/mp4; codecs="av01.0.04M.08"') === 'probably' && 'mediaCapabilities' in navigator;
      videos.forEach((v) => {
        const h264 = v.getAttribute('src');
        if (av1 && v.dataset.av1) {
          v.src = v.dataset.av1;
          v.addEventListener('error', () => {
            if (v.dataset.file === h264 || !v.error || v.error.code < 3) return;
            v.dataset.file = h264;
            if (v.dataset.warm) { v.src = h264; v.load(); }
          });
        }
        v.dataset.file = v.getAttribute('src');
      });

      // One scheduler owns playback and downloads (per-card observers missed fast pans and wraps, and every card that
      // flew past started a download, so the cards on screen starved). Every 150 ms it:
      // - plays every card showing in the lens, even a sliver, and pauses the rest (only once a card has started loading: play() on an idle
      //   card would start a download outside the budget below);
      // - loads at most MAX_LOADING files that cannot yet play through (4 on wide screens, which show ~6 cards; 2 on
      //   phones), cards in the lens first (left to right), then
      //   the next one or two the strip is drifting towards, then the one just behind;
      // - drops half-loaded files of cards that have left that window, so they stop taking bandwidth;
      // - restarts a card on screen whose picture has stalled although it has data.
      // It waits for the billboard film above (seen first) unless the strip itself comes near the screen.
      const MAX_LOADING = matchMedia('(min-width: 768px)').matches ? 4 : 2;
      const lens = track.closest('.reels__lens') || track.parentElement;
      const full = (v) => v.duration > 0 && v.buffered.length > 0 && v.buffered.end(v.buffered.length - 1) >= v.duration - 0.3;
      const start = (v) => {
        v.dataset.warm = '1';
        if (!v.getAttribute('src')) v.src = v.dataset.file;
        v.preload = 'auto';
        v.load();
      };
      const drop = (v) => {
        delete v.dataset.warm;
        v.pause();
        v.removeAttribute('src');
        v.preload = 'none';
        v.load();
      };
      const seen = new Map();
      let go = !!window.__yusheBillboardReady || !document.querySelector('yushe-billboard');
      if (!go) document.addEventListener('yushe:billboard-ready', () => { go = true; }, { once: true });
      const step = () => {
        const lr = lens.getBoundingClientRect();
        const onScreen = lr.bottom > 0 && lr.top < innerHeight;
        if (!go && lr.top < innerHeight * 2) go = true;
        if (!go) return;
        const inLens = [], ahead = [], behind = [], showing = new Set();
        for (const v of videos) {
          const r = v.getBoundingClientRect();
          const w = r.width || 1;
          if (Math.min(r.right, lr.right) - Math.max(r.left, lr.left) > 0) showing.add(v);
          if (Math.min(r.right, lr.right) - Math.max(r.left, lr.left) > w * 0.2) inLens.push([r.left, v]);
          else if (r.left >= lr.right - w * 0.2 && r.left < lr.right + w * 1.6) ahead.push([r.left, v]);
          else if (r.right <= lr.left + w * 0.2 && r.right > lr.left - w * 1.1) behind.push([-r.right, v]);
        }
        const order = [inLens, ahead, behind].flatMap((g) => g.sort((p, q) => p[0] - q[0]).map((e) => e[1]));
        const wanted = new Set(order);
        let loading = 0;
        for (const v of videos) {
          if (!v.dataset.warm) continue;
          if (!wanted.has(v) && !full(v)) drop(v);
          else if (!full(v) && v.readyState < 4) loading++;
        }
        for (const v of order) {
          if (loading >= MAX_LOADING) break;
          if (!v.dataset.warm) { start(v); loading++; }
        }
        const now = performance.now();
        for (const v of videos) {
          const play = onScreen && v.dataset.warm && showing.has(v);
          if (!play) { if (!v.paused) v.pause(); seen.delete(v); continue; }
          if (v.paused) v.play().catch(() => {});
          // Stall guard: has data, not paused, yet the picture has not moved for 2.5 s.
          const last = seen.get(v);
          if (!last || last.t !== v.currentTime) seen.set(v, { t: v.currentTime, at: now });
          else if (now - last.at > 2500 && v.readyState >= 3) { v.pause(); v.play().catch(() => {}); seen.set(v, { t: v.currentTime, at: now }); }
        }
      };
      setInterval(step, 150);
      step();
    }

    // The strip drifts left on its own and can be panned both ways: drag with the mouse, swipe on touch, or scroll
    // sideways on a trackpad. A flick carries on with some momentum, then the drift takes over again. The list is
    // rendered twice, so the offset wraps by one list's width and the strip never runs out.
    function driveReels(track) {
      if (track.dataset.reelsDrive || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const items = track.querySelectorAll('.reels__item');
      const n = track.querySelectorAll('.reels__item[data-reel]').length;
      if (!n || items.length < n * 2) return;
      track.dataset.reelsDrive = '1';
      track.classList.add('is-driven');
      const lens = track.parentElement;
      const DRIFT_SECONDS = 70; // one full list, the pace of the CSS marquee this replaces
      let half = 0, x = 0, vx = 0, pace = 1, hover = false, onScreen = false, raf = 0, last = 0;
      let drag = null, moved = 0;
      const measure = () => { half = items[n].offsetLeft - items[0].offsetLeft; };
      const wrap = () => { if (half > 0) { x %= half; if (x > 0) x -= half; } };
      const paint = () => { track.style.transform = `translate3d(${x}px,0,0)`; };
      function tick(t) {
        const dt = Math.min(0.05, (t - (last || t)) / 1000);
        last = t;
        if (!drag) {
          // The drift eases to a stop under the mouse and picks up again when it leaves.
          pace += ((hover ? 0 : 1) - pace) * Math.min(1, dt * 4);
          x -= (half / DRIFT_SECONDS) * pace * dt;
          x += vx * dt;
          vx *= Math.pow(0.04, dt); // a flick fades out in about a second
          if (Math.abs(vx) < 4) vx = 0;
        }
        wrap(); paint();
        raf = onScreen ? requestAnimationFrame(tick) : 0;
      }
      new IntersectionObserver(([e]) => {
        onScreen = e.isIntersecting;
        if (onScreen && !raf) { last = 0; raf = requestAnimationFrame(tick); }
      }).observe(lens);
      measure();
      addEventListener('resize', measure, { passive: true });

      lens.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hover = true; });
      lens.addEventListener('pointerleave', () => { hover = false; });

      track.addEventListener('pointerdown', (e) => {
        if (e.button !== 0) return;
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: performance.now(), on: e.pointerType === 'mouse' };
        moved = 0; vx = 0;
      });
      track.addEventListener('pointermove', (e) => {
        if (!drag || e.pointerId !== drag.id) return;
        const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (!drag.on) {
          // Touch: a mostly vertical move is the page scrolling; leave it alone.
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) { drag = null; return; }
          if (Math.abs(dx) < 6) return;
          drag.on = true;
        }
        if (!dx) return;
        if (!track.hasPointerCapture(e.pointerId)) { try { track.setPointerCapture(e.pointerId); } catch (_) {} }
        track.classList.add('is-dragging');
        const now = performance.now();
        vx = vx * 0.6 + (dx / (Math.max(1, now - drag.t) / 1000)) * 0.4;
        x += dx; moved += Math.abs(dx);
        drag.x = e.clientX; drag.y = e.clientY; drag.t = now;
        wrap(); paint();
      });
      const end = (e) => {
        if (!drag || e.pointerId !== drag.id) return;
        if (performance.now() - drag.t > 80) vx = 0; // held still before letting go: no fling
        vx = Math.max(-4000, Math.min(4000, vx));
        drag = null;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      // A drag is not a click: don't open the TikTok post at the end of one.
      track.addEventListener('click', (e) => { if (moved > 8) { e.preventDefault(); e.stopPropagation(); } moved = 0; }, true);
      track.addEventListener('dragstart', (e) => e.preventDefault());

      // Sideways trackpad scrolling (or shift + wheel) pans the strip; a plain vertical wheel still scrolls the page.
      lens.addEventListener('wheel', (e) => {
        const dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
        if (!dx) return;
        e.preventDefault();
        x -= dx; vx = 0; wrap(); paint();
      }, { passive: false });
    }
    const run = () => document.querySelectorAll('[data-reels-track]').forEach((t) => { initReels(t); driveReels(t); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-reels-track]').forEach((t) => { initReels(t); driveReels(t); }));
  })();

  } catch(e) { console.error(e); }
})();
})();
